import { colors } from '../../colors';
var location = {
  bgColor: colors.equinePearl,
  cardBgColor: colors.white,
  secondaryBgColor: colors.white,
  cardShadow: colors.equineShadow
};
export default location;